import CadastrarNome from "../componentes/form/cadastrar-nome";


export default function NovaFonteRecurso() {

  return (
    <CadastrarNome
      label='Fonte Recurso'
      labelListagem='Fontes Cadastradas'
      url='/fonteRecurso'/>
  );
}